import { carleadCreationGetInitialProps } from '@wkda/carlead-creation-components';
import {
  BaseConversationalLeadPage,
  CarleadHIWWhyChooseWkdaFaq,
  CarleadStepCompoundBoughtOrOrderedCarConsent,
  createBoughtOrOrderedCarChatFlow,
} from '@wkda/marketing-components';

function CarleadCreation() {
  return (
    <BaseConversationalLeadPage
      content={CarleadHIWWhyChooseWkdaFaq}
      customFlow={createBoughtOrOrderedCarChatFlow}
      manualForm={<CarleadStepCompoundBoughtOrOrderedCarConsent />}
      showTrustPilot={true}
      howItWorksShowCta={true}
    />
  );
}

CarleadCreation.getInitialProps = carleadCreationGetInitialProps;

export default CarleadCreation;
